var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Delete Page")]),_vm._v(" "),_c('button',{staticClass:"delete-btn",on:{"click":_vm.doDelete}},[_vm._v("Delete Page")]),_vm._v(" "),_c('confirm-dialogue',{ref:"confirmDialogue"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }